import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Host,
  Optional,
  Output,
  QueryList,
} from '@angular/core';
import { TabsComponent } from '../tabs.component';
import { TabPanelComponent } from './tab-panel.component';

@Component({
  selector: 'app-tab-panels',
  template: `<ng-content></ng-content>`,
})
export class TabPanelsComponent implements AfterContentInit {
  constructor(@Optional() @Host() public ownerTabs?: TabsComponent) {}

  @ContentChildren(TabPanelComponent, { descendants: false })
  panels!: QueryList<TabPanelComponent>;
  @Output() panelsChange = new EventEmitter<QueryList<TabPanelComponent>>();

  ngAfterContentInit() {
    this.panelsChange.emit(this.panels);
    this.panels.changes.subscribe(() => this.panelsChange.emit(this.panels));
  }
}
